<template>
  <section class="products-section py-3 mb-4 mb-md-6">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <h2 class="title montserrat-bold text-center">
                404 - Página no encontrada
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFound',
  mounted () {
    document.title = 'Página no encontrada | Nexus Technology'
  }
}
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 50px;
}
</style>
